import { buildGoalSections } from '@griply/utils';
import { useGoals } from 'features/goals';
import { useLocalizedLifeAreas } from 'features/life-areas';
import { useMemo } from 'react';
import { useTaskCounts } from 'shared/contexts/task-counts/use-task-counts';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { useUser } from 'shared/hooks/use-user';

export const useGoalSections = () => {
  const user = useUser();
  const goals = useGoals();
  const lifeAreas = useLocalizedLifeAreas();
  const taskCounts = useTaskCounts();
  const links = useEntityLinks();

  return useMemo(
    () =>
      buildGoalSections({
        goals,
        lifeAreas,
        goalSortingMode: user?.settings?.goalSortingMode,
        goalRoadmapSorting: user?.settings?.goalRoadmapSorting,
        goalGroupBy: user?.settings?.goalGroupBy,
        goalGroupSorting: user?.settings?.goalGroupSorting,
        lifeAreaSorting: user?.settings?.lifeAreaSorting,
        taskCounts: taskCounts?.byGoalId,
        goalProgressCounts: taskCounts?.byGoalProgress,
        links,
      }),
    [
      goals,
      lifeAreas,
      links,
      user?.settings?.goalGroupBy,
      user?.settings?.goalGroupSorting,
      user?.settings?.goalRoadmapSorting,
      user?.settings?.goalSortingMode,
      user?.settings?.lifeAreaSorting,
      taskCounts?.byGoalId,
      taskCounts?.byGoalProgress,
    ],
  );
};
